// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AreaChartOutlinedSvg from "@ant-design/icons-svg/es/asn/AreaChartOutlined";
import AntdIcon from '../components/AntdIcon';

var AreaChartOutlined = function AreaChartOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AreaChartOutlinedSvg
  }));
};

AreaChartOutlined.displayName = 'AreaChartOutlined';
export default React.forwardRef(AreaChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AreaChartOutlined.js
// module id = 591
// module chunks = 0